import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import userService from '../services/userService';
import { COMPANY_ID_MAPPINGS } from '../constants/companyIds';

const Register = () => {
  const navigate = useNavigate();
  const { isLoading, error, clearError, login } = useAuth();

  const [form, setForm] = useState({
    username: '',
    password: '',
    name: '',
    email: '',
    company: 'Cia. Zaffari'
  });

  const [localError, setLocalError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError(null);
    clearError?.();

    // Validação simples
    if (!form.username || !form.password || !form.name || !form.email) {
      setLocalError('Preencha todos os campos.');
      return;
    }

    try {
      // Obter os IDs das empresas baseado na seleção
      const allowedCompanies = COMPANY_ID_MAPPINGS[form.company] || [];

      // Usar serviço dedicado para cadastro
      const result = await userService.register({
        username: form.username,
        password: form.password,
        name: form.name,
        email: form.email,
        role: 'user',
        allowedCompanies: allowedCompanies,
        allowedOsTypes: form.company
      });

      if (!result.success) {
        throw new Error(result.error || 'Erro ao cadastrar usuário');
      }

      setSuccessMessage('Cadastro realizado com sucesso! Realizando login...');

      // Após cadastro, realizar login automático
      const loginResult = await login({
        username: form.username,
        password: form.password
      });

      if (loginResult?.success) {
        navigate('/dashboard');
      } else {
        navigate('/login');
      }
    } catch (err) {
      setLocalError(err.message);
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-dark-card rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold text-dark-text mb-4">Criar Conta</h2>
        <p className="text-dark-text-secondary mb-6">Cadastre-se para acessar o dashboard.</p>

        {(localError || error) && (
          <div className="bg-red-900/30 border border-red-700 text-red-200 p-3 rounded mb-4">
            {localError || error}
          </div>
        )}

        {successMessage && (
          <div className="bg-green-900/30 border border-green-700 text-green-200 p-3 rounded mb-4">
            {successMessage}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-dark-text-secondary mb-1">Usuário</label>
            <input
              type="text"
              name="username"
              value={form.username}
              onChange={handleChange}
              className="input-dark w-full"
              placeholder="Seu usuário"
            />
          </div>

          <div>
            <label className="block text-sm text-dark-text-secondary mb-1">Senha</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              className="input-dark w-full"
              placeholder="Sua senha"
            />
          </div>

          <div>
            <label className="block text-sm text-dark-text-secondary mb-1">Nome</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              className="input-dark w-full"
              placeholder="Seu nome completo"
            />
          </div>

          <div>
            <label className="block text-sm text-dark-text-secondary mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="input-dark w-full"
              placeholder="seu@email.com"
            />
          </div>

          <div>
            <label className="block text-sm text-dark-text-secondary mb-1">Empresa</label>
            <select
              name="company"
              value={form.company}
              onChange={handleChange}
              className="input-dark w-full"
            >
              <option value="Cia. Zaffari">Cia. Zaffari</option>
              <option value="Comercial Zaffari">Comercial Zaffari</option>
              <option value="Stok Center">Stok Center</option>
            </select>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-primary hover:bg-primary/90 text-white font-semibold py-2 rounded transition disabled:opacity-50"
          >
            {isLoading ? 'Cadastrando...' : 'Cadastrar'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-primary hover:underline"
          >
            Já tenho conta — fazer login
          </button>
        </div>
      </div>
    </div>
  );
};

export default Register;